export default __webpack_public_path__ + "39c6d8151eddf2f2e3b2e6e8cbb555c0.png";